<div class="status-fornecedor-container">
  <div class="header">
    <h1>Status de Fornecedor</h1>
    <button type="button" class="btn btn-primary" (click)="abrirModalCadastro(modalCadastro)">
      <i class="fa fa-plus"></i> Adicionar novo
    </button>
  </div>

  <div class="card-box mb-3">
    <div class="row g-3 align-items-end">
      <div class="col-md-9">
        <label class="form-label">Filtro por descrição</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="filtroDescricao"
          (keyup)="aplicarFiltros()"
          placeholder="Pesquisar..." />
      </div>
      <div class="col-md-3 d-grid">
        <button type="button" class="btn btn-outline-secondary" (click)="limparFiltros()">
          <i class="fa fa-times"></i> Limpar
        </button>
      </div>
    </div>
  </div>

  <div class="card-box">
    <div class="table-responsive">
      <table class="table table-hover mb-0">
        <thead>
          <tr>
            <th style="width: 90px;">#</th>
            <th>Descrição</th>
            <th style="width: 170px;">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of itensPaginados; let i = index">
            <td>{{ i + 1 + ((paginaAtual - 1) * itensPorPagina) }}</td>
            <td>{{ item.descricao }}</td>
            <td>
              <button type="button" class="btn btn-sm btn-warning me-1" (click)="abrirModalCadastro(modalCadastro, item)" title="Editar">
                <i class="fa fa-edit"></i>
              </button>
              <button type="button" class="btn btn-sm btn-danger" (click)="deletar(item)" title="Excluir">
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr *ngIf="!loading && itensFiltrados.length === 0">
            <td colspan="3" class="text-center text-muted py-3">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-between align-items-center flex-wrap gap-2 mt-3" *ngIf="itensFiltrados.length > 0">
      <div class="d-flex align-items-center gap-2">
        <label class="mb-0">Itens por página:</label>
        <select class="form-control form-control-sm per-page" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="d-flex align-items-center gap-2">
        <span class="text-muted">Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">
          Anterior
        </button>
        <button type="button" class="btn btn-sm btn-outline-secondary" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">
          Próxima
        </button>
      </div>
    </div>
  </div>

  <ng-template #modalCadastro>
    <div class="modal-header">
      <h5 class="modal-title">{{ itemEdicao ? 'Editar Status de Fornecedor' : 'Novo Status de Fornecedor' }}</h5>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef?.dismiss()"></button>
    </div>
    <div class="modal-body">
      <div class="form-group">
        <label class="form-label">Descrição *</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="descricao"
          placeholder="Digite a descrição do status de fornecedor" />
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-outline-secondary" (click)="modalRef?.dismiss()">Cancelar</button>
      <button type="button" class="btn btn-success" (click)="salvar()">
        <i class="fa fa-save"></i> {{ itemEdicao ? 'Salvar edição' : 'Salvar novo' }}
      </button>
    </div>
  </ng-template>
</div>
